/*
 * landing-atc-handler.js — block-scope AJAX submit + cart UI trigger
 *
 * Dawn product-form.js'in sadeleştirilmiş, custom-element-bağımsız hali.
 * <product-form> custom element kullanmaz — constructor crash riski yok.
 *
 * Davranış (settings.cart_type'a göre):
 *   - 'page'         → AJAX add + window.location = '/checkout' (direkt ödeme)
 *   - 'drawer'       → AJAX add + manuel section inject + drawer.open()
 *                      (Dawn cart.renderContents() bu temada drawer'ın ürün listesini
 *                      doğru inject etmiyor; landing-cart-drawer.js upsell extension'ının
 *                      ZATEN test edilmiş manuel parse + innerHTML pattern'i kullanılır)
 *   - 'notification' → AJAX add + cart-notification.renderContents() (toast)
 *                      Notification için section list FARKLI:
 *                      cart-notification-product / cart-notification-button / cart-icon-bubble
 *
 * Hata durumunda fallback: PUB_SUB_EVENTS.cartError publish + /cart redirect.
 *
 * @version 1.5.0 (2026-10-13)
 *   v1.5.0: O2 — paket hediyesi ana ürünün ALT SATIRI olarak eklenir (Shopify iç içe
 *           sepet satırı, `parent_id` = ana varyant, aynı istekte). Ana ürün sepetten
 *           silinince Shopify hediyeyi de siler (partners-deneme'de ölçüldü); önceden
 *           başka ücretli ürün sepetteyse hediye bedava kalıyordu. Shopify iç içe
 *           eklemeyi reddederse (ör. "Cannot reference existing parent lines") bugünkü
 *           bağsız gövde, o da düşerse Y5 hediyesiz gövde denenir — en kötü hâl bugünkü
 *           davranış. Birim seçicide hediye İLK birimin varyantına bağlanır.
 * @version 1.4.1 (2026-10-12)
 *   v1.4.1: "Varyant seçimi eksik" uyarısı sayfa dilinde. Metin artık sabit TÜRKÇE
 *           değil: select'in data-variant-required'ı (landing-product-hero.js bloğun
 *           ayarından yazar) → yedek sözlük (html lang) → "Please choose a variant.".
 *           Başka davranış değişmedi.
 * @version 1.4.0 (2026-09-23)
 *   v1.4.0: Y5 — hediye satırı reddedilirse ANA ÜRÜN hediyesiz olarak TEK kez
 *           daha denenir. `/cart/add` atomik olduğu için geçersiz bir hediye
 *           varyantı (taslağa çekilmiş ayna, silinmiş ürün) ana ürünü de
 *           engelliyordu ve hata yolu yalnız console.warn basıyordu: müşteri
 *           butona basıyor, hiçbir şey olmuyor, SATIŞ sessizce kayboluyordu.
 * @version 1.3.0 (2026-07-10)
 *   v1.3.0: Gift → cart. Seçili bundle tier'ında data-gift-items varsa ana ürünle birlikte
 *           çoklu-item JSON /cart/add ile hediye varyantlarını da ekler (_gift:'true' property).
 *           Hediye yoksa mevcut FormData yolu AYNEN korunur (regresyon yok). $0'lık merchant'ın
 *           Buy X Get Y otomatik indiriminden gelir — tema fiyat belirlemez.
 *   v1.2.1: Production polish — info-level console.log satırları kaldırıldı (script load,
 *           init, bind, submit triggered, cart_type). console.warn (cart error/missing form/
 *           notification fallback) + console.error (submit failed) korundu — gerçek hatalar.
 *   v1.2.0: cartType kilidi — fallback 'page' → 'drawer' + 'notification' otomatik 'drawer'a
 *           çevriliyor. Setting yanlış kalsa bile drawer her zaman tetiklenir.
 *           Mehmet temasında notification/page modları kullanılmıyor, dead-code yönlendirildi.
 *   v1.1.1: Bind logic JS property'ye taşındı (DOM attribute cache kalıntısı sorununa karşı)
 *           + console.log debug satırları eklendi.
 *   v1.1.0: Mode-spesifik section list + manuel drawer render (Mehmet extension pattern) +
 *           page mode artık /checkout'a redirect ediyor (eski /cart yerine).
 *   v1.0.0: İlk sürüm — cart.renderContents() native API'ye güvenildi, drawer kırıldı.
 */
(function () {
  'use strict';

  // v1.4.1 — "varyant seçimi eksik" uyarısının yedeği: select'te
  // data-variant-required yoksa (eski blok / eski hero.js) sayfa diline göre
  // (html lang ilk iki harf; es → es-419, pt → pt-BR). landing-product-hero.js'teki
  // yedek sözlükle AYNI metinler.
  var VARIANT_REQUIRED_TEXTS = {
    en: 'Please choose a variant.',
    es: 'Por favor, elige una variante.',
    de: 'Bitte wähle eine Variante.',
    fr: 'Veuillez choisir une variante.',
    pt: 'Por favor, escolha uma variante.',
    it: 'Per favore, scegli una variante.',
    nl: 'Kies alsjeblieft een variant.',
    tr: 'Lütfen bir varyant seçin.',
    pl: 'Proszę wybrać wariant.'
  };
  function variantRequiredFallback() {
    var lang = String(document.documentElement.lang || '').slice(0, 2).toLowerCase();
    return VARIANT_REQUIRED_TEXTS[lang] || '';
  }

  function init() {
    var blocks = document.querySelectorAll('.landing-hero-product__atc-block');
    blocks.forEach(function (block, i) {
      var form = block.querySelector('form');
      if (!form) {
        console.warn('[landing-atc] block #' + i + ' has no <form>', block);
        return;
      }
      if (form.__landingAtcBound) return;
      form.__landingAtcBound = true;
      form.addEventListener('submit', handleSubmit);
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var block = form.closest('.landing-hero-product__atc-block');
    var cartType = (block && block.dataset.cartType) || 'drawer';
    if (cartType === 'notification') cartType = 'drawer';

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton && submitButton.getAttribute('aria-busy') === 'true') return;
    if (submitButton) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.classList.add('loading');
    }

    try {
      // Mode-spesifik section list
      var sections;
      if (cartType === 'notification') {
        sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
      } else if (cartType === 'drawer') {
        sections = ['cart-drawer', 'cart-icon-bubble'];
      } else {
        sections = ['cart-icon-bubble']; // page mode: sadece bubble update
      }

      var formData = new FormData(form);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);

      // ─── Gift → cart (v1.3.0) ───
      // Seçili bundle tier'ında hediye varyantları varsa (data-gift-items="id:qty,id:qty"),
      // ana ürünle birlikte tek atomik /cart/add çağrısında sepete ekle. Hediye satırları
      // _gift:'true' line-item property'siyle işaretlenir (görünüm/silme JS'i için).
      //
      // ⚠️ 2026-09-23 — "$0'lık merchant'ın Buy X Get Y indiriminden gelir" YORUMU
      // BAYATLAMIŞTI. O model 2026-09-12'de ölçülerek elendi; bedavalık artık
      // 0₺ AYNA ÜRÜNden geliyor (apply varyant id'sini aynanınkiyle değiştirir).
      // Tema yine fiyat belirlemez.
      //
      // 🔴 BİLİNEN RİSK (Y5, henüz düzeltilmedi): bu çağrı ATOMİK — Shopify ya tüm
      // kalemleri ekler ya hiçbirini. Hediye varyantı geçersizse (taslak/silinmiş)
      // ANA ÜRÜN DE sepete girmez ve aşağıdaki hata dalı yalnız console.warn basar,
      // yani müşteri butona bastığında hiçbir şey olmaz. Düzeltme tema push gerektirdiği
      // için ayrı onay bekliyor: `.planning/hediye-zinciri/PLAN.md` → F1.5.
      // Bundle radio ATC formunun DIŞINDA (ayrı section) olduğu için document scope'tan okunur.
      // Y5 (2026-09-23): hediyeler çıkarılmış istek gövdesi. `/cart/add` ATOMİK —
      // Shopify ya tüm kalemleri ekler ya hiçbirini. Hediye varyantı geçersizse
      // (taslağa çekilmiş ayna, silinmiş ürün, stok dışı) ANA ÜRÜN DE sepete
      // girmiyordu ve müşteri butona bastığında hiçbir şey olmuyordu — satış
      // tamamen kayboluyordu, üstelik sessizce.
      var hediyesizGovde = null;
      var bagsizGovde = null;
      var giftItems = [];
      // O2: hediyeyi ana satırın alt satırı yap (Shopify: parent_id = AYNI istekteki varyant).
      function bagla(items, parentVid) {
        return items.map(function (g) {
          return { id: g.id, quantity: g.quantity, properties: g.properties, parent_id: parentVid };
        });
      }
      var checkedTier = document.querySelector('.landing-hero-product__tier-radio:checked');
      if (checkedTier && checkedTier.dataset.giftItems) {
        checkedTier.dataset.giftItems.split(',').forEach(function (pair) {
          var parts = pair.split(':');
          var vid = parseInt((parts[0] || '').trim(), 10);
          var gqty = parseInt((parts[1] || '1').trim(), 10) || 1;
          if (vid) giftItems.push({ id: vid, quantity: gqty, properties: { _gift: 'true' } });
        });
      }

      // ─── Per-unit variant picker (F7-R2/T1) ───
      // Aktif kademede "her ünite için varyant seç" açıksa (data-unit-picks
      // görünür), her <select> için ayrı bir sepet item'ı gönderilir — mainItem
      // YERİNE. Kapsayıcı yoksa/hidden'sa bu blok hiç tetiklenmez, bugünkü
      // davranış (mainItem, tek quantity) birebir korunur.
      var unitItems = [];
      var picksEl = document.querySelector('.landing-hero-product__unit-picks:not([hidden])');
      if (picksEl) {
        var unitSelects = picksEl.querySelectorAll('select[data-unit-index]');
        var firstEmpty = null;
        unitSelects.forEach(function (sel) {
          // Önceki bir "eksik seçim" turundan kalmış olabilecek custom validity'yi
          // temizle — yoksa dolu bir select'te bile reportValidity yanlışlıkla
          // eski hatayı gösterebilir.
          if (typeof sel.setCustomValidity === 'function') sel.setCustomValidity('');
          if (!sel.value && !firstEmpty) firstEmpty = sel;
        });
        if (firstEmpty) {
          // Varsayılan varyantla SESSİZCE gönderme — durdur + görünür uyarı.
          // setCustomValidity ile zorlanıyor çünkü <select> markup'ı başka bir
          // dosyada (landing-product-hero.js) üretiliyor ve `required` taşıyıp
          // taşımadığı bu dosyadan garanti edilemez; bu şekilde native tarayıcı
          // balonu her koşulda görünür.
          if (typeof firstEmpty.setCustomValidity === 'function') {
            firstEmpty.setCustomValidity(
              (firstEmpty.dataset && firstEmpty.dataset.variantRequired) ||
              variantRequiredFallback() ||
              'Please choose a variant.'
            );
          }
          firstEmpty.focus();
          if (typeof firstEmpty.reportValidity === 'function') firstEmpty.reportValidity();
          console.warn('[landing-atc] unit variant seçimi eksik — gönderim durduruldu');
          return;
        }
        var unitMainProps = {};
        var unitSellingPlan = null;
        formData.forEach(function (val, key) {
          var upm = key.match(/^properties\[(.+)\]$/);
          if (upm) unitMainProps[upm[1]] = val;
          if (key === 'selling_plan' && val) unitSellingPlan = val;
        });
        unitSelects.forEach(function (sel) {
          var unitItem = { id: parseInt(sel.value, 10), quantity: 1 };
          if (Object.keys(unitMainProps).length) unitItem.properties = unitMainProps;
          if (unitSellingPlan) unitItem.selling_plan = unitSellingPlan;
          unitItems.push(unitItem);
        });
      }

      var fetchUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      var fetchOpts;
      if (unitItems.length) {
        fetchOpts = {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: unitItems.concat(bagla(giftItems, unitItems[0].id)),
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        };
        // O2 kurtarma gövdesi: hediyeler BAĞSIZ (v1.4.1 davranışı).
        if (giftItems.length) {
          bagsizGovde = { items: unitItems.concat(giftItems), sections: sections.join(','),
                          sections_url: window.location.pathname };
        }
        // Y5 kurtarma gövdesi: hediyeler HARİÇ. Aşağıdaki hata dalı kullanır.
        hediyesizGovde = { items: unitItems, sections: sections.join(','),
                           sections_url: window.location.pathname };
      } else if (giftItems.length) {
        // Ana ürünü form'dan JSON item'a çevir (varsa properties[...] + selling_plan taşınır)
        var mainItem = {
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity'), 10) || 1
        };
        var mainProps = {};
        formData.forEach(function (val, key) {
          var pm = key.match(/^properties\[(.+)\]$/);
          if (pm) mainProps[pm[1]] = val;
          if (key === 'selling_plan' && val) mainItem.selling_plan = val;
        });
        if (Object.keys(mainProps).length) mainItem.properties = mainProps;

        fetchOpts = {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [mainItem].concat(bagla(giftItems, mainItem.id)),
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        };
        bagsizGovde = { items: [mainItem].concat(giftItems), sections: sections.join(','),
                        sections_url: window.location.pathname };
        hediyesizGovde = { items: [mainItem], sections: sections.join(','),
                           sections_url: window.location.pathname };
      } else {
        fetchOpts = {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        };
      }

      var response = await fetch(fetchUrl, fetchOpts);
      var data = await response.json();

      if (data.status && bagsizGovde) {
        // ─── O2 KURTARMA: iç içe ekleme reddedildiyse bağsız hediyeyle TEK deneme ───
        // (bugünkü v1.4.1 gövdesi — hediye ana ürüne bağlanamasa da kaybolmasın)
        console.warn('[landing-atc] iç içe hediye reddedildi, bağsız deneniyor', data);
        try {
          var r1 = await fetch(fetchUrl, {
            method: 'POST',
            headers: {
              'Accept': 'application/javascript',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(bagsizGovde)
          });
          var d1 = await r1.json();
          if (!d1.status) data = d1;
        } catch (e) {
          console.warn('[landing-atc] bağsız deneme de başarısız', e);
        }
      }
      if (data.status) {
        // ─── Y5 KURTARMA: hediyesiz TEK bir yeniden deneme ───
        // Hediye satırı yüzünden düştüyse müşteriyi eli boş bırakma; ana ürün
        // sepete girsin. Hediye kaybolur ama SATIŞ kaybolmaz. Tek tekrar,
        // döngü yok; ikinci deneme de düşerse bugünkü davranışa dönülür.
        if (hediyesizGovde && giftItems.length) {
          console.warn('[landing-atc] hediye satırı reddedildi, hediyesiz tekrar deneniyor', data);
          try {
            var r2 = await fetch(fetchUrl, {
              method: 'POST',
              headers: {
                'Accept': 'application/javascript',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(hediyesizGovde)
            });
            var d2 = await r2.json();
            if (!d2.status) {
              // Ana ürün girdi. Hediyenin neden giremediği merchant'ın
              // teşhis edebilmesi için konsolda kalır; müşteriye sahte bir
              // "hediye eklendi" mesajı GÖSTERİLMEZ.
              console.warn('[landing-atc] ana ürün hediyesiz eklendi — hediye varyantı geçersiz');
              data = d2;
            }
          } catch (e) {
            console.warn('[landing-atc] hediyesiz tekrar da başarısız', e);
          }
        }
      }
      if (data.status) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'landing-atc',
            productVariantId: formData.get('id'),
            errors: data.errors || data.description,
            message: data.message
          });
        }
        console.warn('[landing-atc] cart add rejected', data);
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'landing-atc',
          productVariantId: formData.get('id'),
          cartData: data
        });
      }

      // ─── Mode'a göre UI ───
      if (cartType === 'page') {
        // Direkt ödeme sayfası
        window.location = '/checkout';
        return;
      }

      if (cartType === 'notification') {
        var notif = document.querySelector('cart-notification');
        if (notif && typeof notif.renderContents === 'function') {
          notif.cartItemKey = (data.items && data.items[0] && data.items[0].key) || data.key;
          notif.renderContents(data);
        } else {
          console.warn('[landing-atc] cart-notification element DOM\'da yok — /cart\'a fallback');
          window.location = '/cart';
        }
        return;
      }

      // Drawer mode — Mehmet extension pattern (manuel section inject)
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) {
        window.location = '/cart';
        return;
      }

      var parser = new DOMParser();

      if (data.sections && data.sections['cart-drawer']) {
        var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
        var newInner = doc.querySelector('#CartDrawer');
        var currentInner = drawer.querySelector('#CartDrawer');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }
      }

      if (data.sections && data.sections['cart-icon-bubble']) {
        var iconWrapper = document.querySelector('#cart-icon-bubble');
        if (iconWrapper) {
          var iconDoc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var newBubble = iconDoc.querySelector('.shopify-section');
          if (newBubble) iconWrapper.innerHTML = newBubble.innerHTML;
        }
      }

      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();

      // landing-cart-drawer.js extension bunu dinler (upsell button re-bind)
      document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true }));

    } catch (err) {
      console.error('[landing-atc] submit failed', err);
      window.location = cartType === 'page' ? '/checkout' : '/cart';
    } finally {
      if (submitButton) {
        submitButton.removeAttribute('aria-busy');
        submitButton.classList.remove('loading');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
